import get from "lodash/get";

export const getUXSettingsFromStorage = (uxKey) => {
  if (!uxKey) return {};

  const uxStorage = localStorage.getItem("persist:payference");
  const parsedUxStorage = uxStorage
    ? JSON.parse(get(JSON.parse(uxStorage), "ux", null))
    : "";

  return parsedUxStorage && get(parsedUxStorage, uxKey, "")
    ? get(parsedUxStorage, uxKey, {})
    : {};
};
